import * as React from 'react';
import AiAssistantsModal from '../AiAssistantsModal';
import BackToTopButton from '../BackToTopButton';

function Pricing({subscriptionStatus} :any) {
  function alreadySubscribedLabel() {
    if (subscriptionStatus == 'already_subscribed') {
      return 'You are already a premium member!';
    } else {
      return 'Upgrade to Premium';
    }
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/profile">Profile</a></li>
            <li className="breadcrumb-item active" aria-current="page">Pricing</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-md-4 grid-margin stretch-card pricing-card">
          <div className="card">
            <div className="card-body">
              <div className="text-center pricing-card-head">
                <h3>Free</h3>
                <h3 className="font-weight-normal mb-4"><small>$</small>0.00</h3>
              </div>
              <ul className="plan-features">
                <li>Discover wonderful businesses</li>
                <li>Automated fundamental analysis and ranking for all US public companies</li>
                <li>Automated valuation and recommendations for all US public companies based on value investing principles</li>
                <li>Automated assistance to your due diligence for stock investments</li>
                <li>Instantly find out the financial health of a business</li>
                <li>80 company look-ups</li>
                <li>50 stock screen previews</li>
                <li>Leaderboard that ranks the best companies</li>
                <li>Stock screener for discovering wonderful businesses</li>
                <li>Automated Fair value & Margin-Of-Safety price calculations</li>
                <li>Fair Value and Margin-Of-Safety price valuation calculator</li>
                <li>Estimates a `Buy`, `Don't Buy`, `Hold`, or `Sell` consideration for every stock</li>
                <li>Automated historical growth rates calculation for key financial metrics.</li>
                <li>10+ years of key financial metrics for every US public company</li>
                <li>Access to SEC 10-K, 20-F, 40-F, 8K and 10-Q filings</li>
                <li><strong>AI Assistants</strong></li>
                <ul>
                  <li>8 questions/tasks to <strong>Lima</strong>, our AI Stock Market Research Analyst</li>
                  <li>8 earnings call questions to <strong>Saturday</strong>, our AI Stock Market Research Assistant</li>
                  <li>4 questions/tasks on 10-K, 10-Q, and 8-K filing documents to <strong>June</strong>, our advanced and sophisticated AI Stock Market Research Assistant</li>
                  <li>Free answers from AI assistants</li>
                </ul>
                <li><strong>Autonomous AI Agents</strong></li>
                <ul>
                  <li>8 autonomous AI generated insights</li>
                </ul>
              </ul>
              <div className="wrapper">
                <a href="/profile" className="btn btn-outline-primary btn-block">Continue</a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 grid-margin stretch-card pricing-card">
          <div className="card">
            <div className="card-body">
              <div className="text-center pricing-card-head">
                <h3 className="text-success">Premium Plan</h3>
                <h3 className="font-weight-normal mb-4"><small>$</small>119.88/year or <small>$</small>12.99/month</h3>
              </div>
              <ul className="plan-features">
                <li>Save valuations for companies using your own assumptions</li>
                <li>Discover when your favorite stocks are undervalued using your own saved assumptions</li>
                <li>Add stocks you love to your favorites list</li>
                <li>Track the performance and valuations of the stocks you love</li>
                <li>Unlimited company look-ups</li>
                <li>Create unlimited watchlists</li>
                <li>Create unlimited stock screens</li>
                <li>Discover new companies and investment opportunities with your pre-set screeners and assumptions.</li>
                <li><strong>AI Assistants</strong></li>
                <ul>
                  <li>40 questions/tasks to <strong>Lima</strong>, our most advanced AI Stock Market Research Analyst every 30 days.</li>
                  <li>40 earnings call questions to <strong>Saturday</strong>, our AI Stock Market Analyst every 30 days.</li>
                  <li>40 questions/tasks on SEC filings to <strong>June</strong>, our AI Stock Market Analyst every 30 days.</li>
                </ul>
                <p className="credit-note">All unused credits accumulate until used.</p>
                <li><strong>Autonomous AI Agents</strong></li>
                <ul>
                  <li>40 autonomous AI generated insights every 30 days (Unused credits accumulate until used)</li>
                </ul>
                <li>Includes all FREE plan features</li>
              </ul>
              <div className="wrapper">
                <form method='post' action={ '/subscriptions/premium' } >
                  <button disabled={ ((subscriptionStatus == 'premium') || (subscriptionStatus == 'executive')) ? true : false } type="submit" className="btn btn-success btn-block">{ ((subscriptionStatus == 'premium') || (subscriptionStatus == 'executive')) ? 'You are already subscribed' : 'Upgrade to Premium' }</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 grid-margin stretch-card pricing-card">
          <div className="card">
            <div className="card-body">
              <div className="text-center pricing-card-head">
                <h3 className="text-info">Executive Plan</h3>
                <h3 className="font-weight-normal mb-4"><small>$</small>299.88/year or <small>$</small>29.99/month</h3>
              </div>
              <ul className="plan-features">
                <li><strong>AI Assistants (Unlimited questions/tasks)</strong></li>
                <ul>
                  <li><strong>Unlimited</strong> questions/tasks to <strong>Lima</strong>, our AI Stock Market Research Analyst</li>
                  <li><strong>Unlimited</strong> earnings call questions to <strong>Saturday</strong>, our AI Stock Market Research Assistant</li>
                  <li><strong>Unlimited</strong> questions/tasks on 10-K, 10-Q, and 8-K filing documents to <strong>June</strong>, our advanced and sophisticated AI Stock Market Research Assistant</li>
                </ul>
                <li><strong>Autonomous AI Agents</strong></li>
                <ul>
                  <li>100 autonomous AI generated insights every 30 days. Unused credits will accumulate until used.</li>
                </ul>
                <li>Includes all FREE and Premium plan features</li>
              </ul>
              <div className="wrapper">
                <form method='post' action={ '/subscriptions/executive' } >
                  <button disabled={ ((subscriptionStatus == 'premium') || (subscriptionStatus == 'executive')) ? true : false } type="submit" className="btn btn-info btn-block">{ ((subscriptionStatus == 'premium') || (subscriptionStatus == 'executive'))  ? 'You are already subscribed!' : 'Upgrade to Executive' }</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 grid-margin stretch-card pricing-card">
          <div className="card">
            <div className="card-body">
              <div className="text-center pricing-card-head">
                <h3 className="text-info">Enterprise Plan</h3>
              </div>
              <ul className="plan-features">
                <li>AI Stock Market Analysts customized to screen and analyze stocks using your investment strategies, at scale.</li>
                <li>Includes all FREE, Premium plan and Executive plan features</li>
              </ul>
              <div className="wrapper">
                <form method='post' action={ 'mailto:support@decodeinvesting.com?subject=Enterprise Plan: Ready to discuss our needs' } >
                  <button type="submit" className="btn btn-info btn-block">Contact Us</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTopButton/>
    </div>
  );
}

export default Pricing;
